import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import LogosAdvancedFieldsConfig from "segments/desktop/core-components/logos/advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    alignToLogo: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Align to logo (New)"
    },
    segmentHeight: {
      type: FIELD_TYPES.TEXT,
      label: "Segment Height"
    },
    segmentMinHeight: {
      type: FIELD_TYPES.TEXT,
      label: "Segment Min Height"
    },
    segmentMaxHeight: {
      type: FIELD_TYPES.TEXT,
      label: "Segment Max Height"
    },
    ...SharedAdvancedFieldsConfig,
    paragraphAdvancedProps: {
      type: FIELD_TYPES.NESTED,
      label: "Paragraph Advanced Props",
      fields: FullParagraphAdvancedFieldsConfig
    },
    topLogosAdvancedProps: {
      type: FIELD_TYPES.NESTED,
      label: "Logos Advanced Props",
      fields: {
        textAndLogosMargin: { type: FIELD_TYPES.TEXT, label: "Space between text and logo" },
        logosAdvancedProps: {
          type: FIELD_TYPES.NESTED,
          label: "Logos Advanced Props",
          fields: LogosAdvancedFieldsConfig
        }
      }
    }
  }
};
